/**
 * Prebid.js fallback setup - provides stub methods when Prebid isn't loaded
 * @module lib/prebidFallback
 */

function ensurePrebidFallback(pbjs) {
  if (!pbjs || pbjs._millaPrebidFallbackApplied) {
    return;
  }

  pbjs._millaPrebidFallbackApplied = true;

  const noop = function () {};
  pbjs.setConfig = pbjs.setConfig || noop;
  pbjs.addAdUnits = pbjs.addAdUnits || noop;
  pbjs.setTargetingForGPTAsync = pbjs.setTargetingForGPTAsync || noop;
  pbjs.getAdUnits = pbjs.getAdUnits || function () {
    return Array.isArray(pbjs.adUnits) ? pbjs.adUnits : [];
  };
  pbjs.getAdserverTargetingForAdUnitCode =
    pbjs.getAdserverTargetingForAdUnitCode || function () {
      return {};
    };
  pbjs.requestBids =
    pbjs.requestBids ||
    function (options = {}) {
      if (typeof options.bidsBackHandler === 'function') {
        setTimeout(options.bidsBackHandler, 0);
      }
    };

  const queued = Array.isArray(pbjs.que) ? pbjs.que.slice() : [];
  pbjs.que = Array.isArray(pbjs.que) ? pbjs.que : [];
  pbjs.que.push = function (fn) {
    if (typeof fn === 'function') {
      fn();
    }
    return Array.prototype.push.call(pbjs.que, fn);
  };

  queued.forEach((fn) => {
    if (typeof fn === 'function') {
      fn();
    }
  });
}

// The display factories wait this long for the Prebid bundle to run before
// starting without it (matches the Stories cap in adInitializer).
const PREBID_LOAD_FAILSAFE_MS = 3000;

module.exports = { ensurePrebidFallback, PREBID_LOAD_FAILSAFE_MS };
